export default __webpack_public_path__ + "bb7d1a802737b5ab84fecc66b3bb0d79.png";